export function parseStoredRoles(storage) {
  const safeStorage = storage ?? (typeof window !== "undefined" ? window.localStorage : undefined);

  if (!safeStorage?.getItem) return [];

  let parsedRoles = [];
  try {
    const raw = JSON.parse(safeStorage.getItem("userRoles") || "[]");
    parsedRoles = Array.isArray(raw) ? raw : [];
  } catch {
    parsedRoles = [];
  }

  const fallbackRole = safeStorage.getItem("userRole");
  return Array.from(
    new Set(
      [...parsedRoles, fallbackRole]
        .filter(Boolean)
        .map((role) => String(role).trim().toLowerCase())
    )
  );
}

function normalizeName(value) {
  return String(value || "").trim().toLowerCase();
}

function normalizePhone(value) {
  return String(value || "").replaceAll(/\D/g, "");
}

export function buildPatientAccessKey(firstname, lastname, phoneNumber) {
  return `${normalizeName(firstname)}|${normalizeName(lastname)}|${normalizePhone(
    phoneNumber
  )}`;
}

export function hasAcceptedEligibilityStatus(status) {
  return ["accepted", "completed"].includes(String(status || "").toLowerCase());
}

export function filterVisiblePatients(
  patients,
  isDoctorRole,
  doctorEligibilityRequests
) {
  if (!Array.isArray(patients)) return [];
  if (!isDoctorRole) return patients;

  const acceptedRequests = (Array.isArray(doctorEligibilityRequests)
    ? doctorEligibilityRequests
    : []
  ).filter((row) => hasAcceptedEligibilityStatus(row?.status));

  const authorizedPatientIds = new Set(
    acceptedRequests
      .map((row) => Number(row?.patientId))
      .filter((id) => Number.isFinite(id) && id > 0)
  );

  const authorizedPatientKeys = new Set(
    acceptedRequests
      .map((row) =>
        buildPatientAccessKey(
          row?.patientFirstname,
          row?.patientLastname,
          row?.phoneNumber
        )
      )
      .filter((key) => key !== "||")
  );

  return patients.filter((patient) => {
    const patientId = Number(patient?.id);
    if (authorizedPatientIds.has(patientId)) return true;

    return authorizedPatientKeys.has(
      buildPatientAccessKey(
        patient?.firstname,
        patient?.lastname,
        patient?.phoneNumber
      )
    );
  });
}

export function selectPatientFromNavigation(visiblePatients, locationState) {
  if (!Array.isArray(visiblePatients) || visiblePatients.length === 0) return null;

  const targetId = Number(locationState?.selectedPatientId);
  if (Number.isFinite(targetId)) {
    const found = visiblePatients.find((patient) => Number(patient?.id) === targetId);
    if (found) return found;
  }

  return visiblePatients[0];
}

export function getStatsErrorDescription(isDoctorRole, t) {
  if (isDoctorRole) {
    return t(
      "stats_error_doctor_description",
      "Vérifie GET /patients, GET /eligibility-request?view=doctor et ton token."
    );
  }

  return t(
    "stats_error_description",
    "Verifie GET /patients/pace|match|path et ton token."
  );
}

export function getEmptyPatientsMessage(isDoctorRole, programType, t) {
  if (isDoctorRole) {
    return t(
      "stats_no_patient_doctor",
      "Aucun patient avec requete d'eligibilite acceptee."
    );
  }

  return t("stats_no_patient_for_program", {
    programType,
    defaultValue: "Aucun patient pour {{programType}}",
  });
}
